import _ from "lodash";
import * as Yup from "yup";

import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import {SubFormDefinition} from "../../../../../utils/forms/components/FormSet";

function sum(input) {
    if (toString.call(input) !== "[object Array]") return false;

    var total = 0;
    for (var i = 0; i < input.length; i++) {
        if (isNaN(input[i])) {
            continue;
        }
        total += Number(input[i]);
    }
    return total;
}

const positiveIntegerValidation = () =>
    Yup.number()
        .required("Field is required.")
        .min(0, "Value must be >= 0.")
        .test(
            "integer",
            "Value must be integer.",
            value => value == null || Number.isInteger(value)
        );

const getSubtypes = values => {
    if (Object(values).hasOwnProperty("type") && (values.type === 2 || values.type === 1 || values.type === 8)) {
        return [
            {
                value: "parent",
                label: "Shared Prizes"
            },
            {
                value: "child",
                label: "Prog. Group Prizes"
            }
        ];
    } else if (Object(values).hasOwnProperty("type") && values.type === 0) {
        return [
            {
                value: 0,
                label: "All Prizes"
            }
        ];
    } else if (Object(values).hasOwnProperty("type") && values.type === 3) {
        return [
            {
                label: "Grand",
                value: "parent"
            },
            {
                label: "Minor",
                value: "child"
            }
        ];
    } else if (Object(values).hasOwnProperty("type") && values.type === 4) {
        return [
            {
                value: "single",
                label: "Single Prize"
            }
        ];
    } else if (Object(values).hasOwnProperty("type") && (values.type === 7 || values.type === 9)) {
        return [
            {
                value: "child",
                label: "Prog. Group Prizes"
            }
        ];
    }

    return [
        {
            value: "parent",
            label: "Shared Prizes"
        },
        {
            value: "child",
            label: "Prog. Group Prizes"
        },
        {
            value: null,
            label: "All Prizes"
        }
    ];
};

const getJackpotTypes = (subsidiary) => {
    let types = [
        {
            label: "Levels",
            value: 0
        },
        {
            label: "Multipots",
            value: 1
        },
        {
            label: "EasyLink",
            value: 2
        },
        {
            label: "Fractionated",
            value: 4
        },
        {
            label: "Reel Strike",
            value: 7
        },
        {
            label: "Jumbo Link",
            value: 8
        }
    ];
    if (subsidiary == "1" || subsidiary == "2" || subsidiary == "3" || subsidiary == "4" || subsidiary == "6" || subsidiary == "9" || subsidiary == "10") {
        types.push({label: "SAP", value: 3});
    }
    if (subsidiary == "1" || subsidiary == "9" || subsidiary == "12" || subsidiary == "10") {
        types.push({label: "LuckyToken", value: 9});
    }
    return types;
};

export const baseConfigInitialFields = _.memoize(
    ({subsidiaries, values, isDisabled, isNameDisabled}): FormGridField[] => [
        {
            name: "name",
            fieldType: "input",
            fieldOptions: {
                id: "name",
                placeholder: "Preset Name",
                inputType: "text",
                label: "Preset Name",
                disabled: isNameDisabled
            },
            validation: Yup.string()
                .required("Field is required.")
                .max(20, "Max. 20 characters.")
                .matches(
                    new RegExp(/^[\w\-\ \.]+$/),
                    `Special characters not supported.`
                ),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "subsidiary",
            fieldType: "select",
            fieldOptions: {
                id: "subsidiary_preset",
                noValueLabel: "Choose subsidiary",
                label: "Subsidiary",
                items: subsidiaries,
                disabled: isDisabled
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "type",
            fieldType: "select",
            fieldOptions: {
                id: "type_preset",
                noValueLabel: "Choose Jackpot Type",
                label: "Jackpot Type",
                items: getJackpotTypes(Object(values).hasOwnProperty("subsidiary") && values.subsidiary),
                disabled: isDisabled,
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "stype",
            fieldType: "select",
            fieldOptions: {
                id: "stype_preset",
                noValueLabel: "Choose Prize Type",
                label: "Prize Type",
                items: getSubtypes(values),
                disabled: isDisabled
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "notes",
            fieldType: "input",
            fieldOptions: {
                id: "notes",
                placeholder: "Notes",
                inputType: "text",
                label: "Notes"
            },
            columnClass: "col-12",
            formSpacing: false
        }
    ]
);

export const settingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);

export const settingsConfigFieldsNoCoin = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);

export const easylinkSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode0",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode0",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode1",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode1",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode2",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode2",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode3",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode3",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode4",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode4",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        },
        {
            name: "buytype_settings_group",
            fieldType: "group",
            fieldOptions: {
                id: "buytypeSettingsGroup",
                inputType: "group",
                label: "Buy Bonus Settings (optional)"
            },
            formSpacing: false,
            columnClass: "col-12"
        },
        {
            name: "buytype_frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: positiveIntegerValidation(),
            columnClass: "col-3",
            formSpacing: false
        }
    ]
);

export const easylinkSettingsConfigFieldsNoCoin = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode0",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode0",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode1",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode1",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode2",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode2",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode3",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode3",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_game_mode4",
            fieldType: "number",
            fieldOptions: {
                id: "min_game_mode4",
                placeholder: "Min. Game Mode",
                inputType: "text",
                label: "Min. Game Mode 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        },
        {
            name: "buytype_settings_group",
            fieldType: "group",
            fieldOptions: {
                id: "buytypeSettingsGroup",
                inputType: "group",
                label: "Buy Bonus Settings (optional)"
            },
            formSpacing: false,
            columnClass: "col-12"
        },
        {
            name: "buytype_frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "buytype_prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "buytype_prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            /*
            validation: Yup.string()
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        if (typeof value !== 'undefined') {
                            if(
                                typeof this.parent.buytype_frequency_prize0 == 'undefined' ||
                                typeof this.parent.buytype_frequency_prize1 == 'undefined' ||
                                typeof this.parent.buytype_frequency_prize2 == 'undefined' ||
                                typeof this.parent.buytype_frequency_prize3 == 'undefined' ||
                                typeof this.parent.buytype_frequency_prize4 == 'undefined')

                                return false
                            else
                                return (
                                    sum([
                                        this.parent.buytype_frequency_prize0,
                                        this.parent.buytype_frequency_prize1,
                                        this.parent.buytype_frequency_prize2,
                                        this.parent.buytype_frequency_prize3,
                                        this.parent.buytype_frequency_prize4
                                    ]) < value
                            );
                        }else {
                             return !(typeof this.parent.buytype_frequency_prize0 !== 'undefined' ||
                                 typeof this.parent.buytype_frequency_prize1 !== 'undefined' ||
                                 typeof this.parent.buytype_frequency_prize2 !== 'undefined' ||
                                 typeof this.parent.buytype_frequency_prize3 !== 'undefined' ||
                                 typeof this.parent.buytype_frequency_prize4 !== 'undefined');
                        }
                    }
                })
                .nullable(),*/
            columnClass: "col-3",
            formSpacing: false
        }
    ]
);

export const levelSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
    ]
);

export const sapSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "terminal_rtp_weight",
            fieldType: "number",
            fieldOptions: {
                id: "terminal_rtp_weight",
                placeholder: "RTP Weight",
                inputType: "text",
                label: "Terminal RTP Weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "terminal_progressive_rtp_weight",
            fieldType: "number",
            fieldOptions: {
                id: "terminal_progressive_rtp_weight",
                placeholder: "Prog. RTP Weight",
                inputType: "text",
                label: "Terminal Prog. RTP weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "player_coinin_weight",
            fieldType: "number",
            fieldOptions: {
                id: "player_coinin_weight",
                placeholder: "Coin In Weight",
                inputType: "text",
                label: "Player Coin In weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "progressive_redraw_time",
            fieldType: "number",
            fieldOptions: {
                id: "progressive_redraw_time",
                placeholder: "Progressive Redraw Time",
                inputType: "text",
                label: "Progressive Redraw Time (s)"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(15, "Value must be >= 15."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })).required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        },
        {
            name: "reserve_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "reserve_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Reserve value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })).required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);

export const sapSettingsConfigFieldsNoCoin = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "terminal_rtp_weight",
            fieldType: "number",
            fieldOptions: {
                id: "terminal_rtp_weight",
                placeholder: "RTP Weight",
                inputType: "text",
                label: "Terminal RTP Weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "terminal_progressive_rtp_weight",
            fieldType: "number",
            fieldOptions: {
                id: "terminal_progressive_rtp_weight",
                placeholder: "Prog. RTP Weight",
                inputType: "text",
                label: "Terminal Prog. RTP weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "player_coinin_weight",
            fieldType: "number",
            fieldOptions: {
                id: "player_coinin_weight",
                placeholder: "Coin In Weight",
                inputType: "text",
                label: "Player Coin In weight"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "progressive_redraw_time",
            fieldType: "number",
            fieldOptions: {
                id: "progressive_redraw_time",
                placeholder: "Progressive Redraw Time",
                inputType: "text",
                label: "Progressive Redraw Time"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(15, "Value must be >= 15."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })).required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        },
        {
            name: "reserve_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "reserve_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Reserve value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })).required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);

export const MultipotsSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    },
                    {
                        value: "fractionated",
                        label: "Fractionated"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        }
    ]
);

export const MultipotsSettingsConfigFieldsWithFrac = _.memoize(
    (): FormGridField[] => {
        return [
            {
                name: "proportion_type",
                fieldType: "select",
                fieldOptions: {
                    id: "proportion_type",
                    noValueLabel: "Proportion Type...",
                    label: "Proportion Type",
                    items: [
                        {
                            value: "fractionated",
                            label: "Fractionated"
                        }
                    ]
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-3"
            },
            {
                name: "rtp",
                fieldType: "input",
                fieldOptions: {
                    id: "rtp",
                    inputType: "text",
                    label: "RTP",
                    placeholder: "RTP",
                },
                columnClass: "col-9",
                formSpacing: false
            }
        ]
    }
);

export const ReelStrikeSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => {
        let items = [...coins];
        items.unshift({label: 'Bet', value: 0});
        let fieldsValidations = {}
        items.map((item) => {
                if (item.value === 0) return fieldsValidations[item.value] = Yup.number()
                    .required(`Field for ${item.label} is required. `)
                    .min(1, `Field for ${item.label} must be ≥ than 1`)
                else return fieldsValidations[item.value] = Yup.number()
                    .required(`Field for ${item.label} is required. `)
                    .min(0, `Field for ${item.label} must be ≥ than 0`)
            }
        )
        const validations = Yup.array(Yup.object(fieldsValidations)).required("Field is required.");

        return [
            {
                name: "coin",
                fieldType: "bulletsSelector",
                fieldOptions: {
                    id: "proportional_coin",
                    inputType: "bulletsSelector",
                    label: "Coin",
                    items: coins,
                    completeList: coins
                },
                validation: Yup.string().required("Field is required."),
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },
            {
                name: "min_room_games_started",
                fieldType: "number",
                fieldOptions: {
                    id: "min_room_games_started",
                    placeholder: "Min. Room Games Started",
                    inputType: "text",
                    label: "Min. Room Games Started"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "proportion_type",
                fieldType: "select",
                fieldOptions: {
                    id: "proportion_type",
                    noValueLabel: "Proportion Type...",
                    label: "Proportion Type",
                    items: [
                        {
                            value: "normal",
                            label: "Normal"
                        }
                    ]
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-3"
            },
            {
                name: "min_machine_coin_in0",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in0",
                    placeholder: "Min. Machine Coin In 0",
                    inputType: "text",
                    label: "Min. Machine Coin In 0"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_machine_coin_in1",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in1",
                    placeholder: "Min. Machine Coin In 1",
                    inputType: "text",
                    label: "Min. Machine Coin In 1"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_machine_coin_in2",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in2",
                    placeholder: "Min. Machine Coin In 2",
                    inputType: "text",
                    label: "Min. Machine Coin In 2"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_machine_coin_in3",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in3",
                    placeholder: "Min. Machine Coin In 3",
                    inputType: "text",
                    label: "Min. Machine Coin In 3"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_machine_coin_in4",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in4",
                    placeholder: "Min. Machine Coin In 4",
                    inputType: "text",
                    label: "Min. Machine Coin In 4"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "rtp",
                fieldType: "input",
                fieldOptions: {
                    id: "rtp",
                    inputType: "text",
                    label: "RTP",
                    placeholder: "RTP",
                },
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },
            {
                name: "frequency_prizes_list0",
                fieldType: "betFreqPrizesArray",
                fieldOptions: {
                    id: "frequency_prizes_list0",
                    items: items,
                    inputType: "text",
                    label: "Frequency Prizes List 0"
                },
                validation: validations,
                columnClass: "col-12",
                formSpacing: false
            },
            {
                name: "frequency_prizes_list1",
                fieldType: "betFreqPrizesArray",
                fieldOptions: {
                    id: "frequency_prizes_list1",
                    items: items,
                    inputType: "text",
                    label: "Frequency Prizes List 1"
                },
                validation: validations,
                columnClass: "col-12",
                formSpacing: false
            },
            {
                name: "frequency_prizes_list2",
                fieldType: "betFreqPrizesArray",
                fieldOptions: {
                    id: "frequency_prizes_list2",
                    items: items,
                    inputType: "text",
                    label: "Frequency Prizes List 2"
                },
                validation: validations,
                columnClass: "col-12",
                formSpacing: false
            },
            {
                name: "frequency_prizes_list3",
                fieldType: "betFreqPrizesArray",
                fieldOptions: {
                    id: "frequency_prizes_list3",
                    items: items,
                    inputType: "text",
                    label: "Frequency Prizes List 3"
                },
                validation: validations,
                columnClass: "col-12",
                formSpacing: false
            },
            {
                name: "frequency_prizes_list4",
                fieldType: "betFreqPrizesArray",
                fieldOptions: {
                    id: "frequency_prizes_list4",
                    items: items,
                    inputType: "text",
                    label: "Frequency Prizes List 4"
                },
                validation: validations,
                columnClass: "col-12",
                formSpacing: false
            }
        ]
    }
);

export const FracSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => {
        let fieldsValidations = {}
        coins.map((coin) => fieldsValidations[coin.value] = Yup.number()
            .required(`Field for ${coin.label} is required. `)
            .min(0, `Field for ${coin.label} must be ≥ than 0`)
            .max(100, `Field for ${coin.label} must be ≤ than 100`)
        )
        return [
            {
                name: "initial_value",
                fieldType: "number",
                fieldOptions: {
                    id: "initial_value",
                    placeholder: "Initial Value",
                    inputType: "text",
                    label: "Initial Value"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .max(42949672.95, `Must be <= than 42949672.95`)
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "max_value",
                fieldType: "number",
                fieldOptions: {
                    id: "max_value",
                    placeholder: "Maximum Value",
                    inputType: "text",
                    label: "Maximum Value"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .max(42949672.95, `Must be <= than 42949672.95`)
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "contribution",
                fieldType: "number",
                fieldOptions: {
                    id: "contribution",
                    placeholder: "Contribution",
                    inputType: "text",
                    label: "Contribution"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .max(5, `Must be <= than 5`)
                    .min(0.01, `Must be >= than 0.01`),
                columnClass: "col-3 percentage",
                formSpacing: false
            },
            {
                name: "proportion_type",
                fieldType: "select",
                fieldOptions: {
                    id: "proportion_type",
                    noValueLabel: "Proportion Type...",
                    label: "Proportion Type",
                    items: [
                        {
                            value: "fractionated",
                            label: "Fractionated"
                        }
                    ]
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-3"
            },
            {
                name: "rtp",
                fieldType: "input",
                fieldOptions: {
                    id: "rtp",
                    inputType: "text",
                    label: "RTP",
                    placeholder: "RTP",
                },
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },
            {
                name: "fractionated_jackpot_list",
                fieldType: "betJackpotArray",
                fieldOptions: {
                    id: "fractionated_jackpot_list",
                    items: coins,
                    inputType: "text",
                    label: "Fractionated Jackpot List"
                },
                validation: Yup.array(Yup.object(fieldsValidations)).required("Field is required."),
                columnClass: "col-12",
                formSpacing: false
            }

        ]
    }
);

export const JumboLinkSettingsConfigFields = _.memoize(
    ({coins}): FormGridField[] => {
        return [
            {
                name: "coin",
                fieldType: "bulletsSelector",
                fieldOptions: {
                    id: "proportional_coin",
                    inputType: "bulletsSelector",
                    label: "Coin",
                    items: coins,
                    completeList: coins
                },
                validation: Yup.string().required("Field is required."),
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },
            {
                name: "proportion_type",
                fieldType: "select",
                fieldOptions: {
                    id: "proportion_type",
                    noValueLabel: "Proportion Type...",
                    label: "Proportion Type",
                    items: [
                        {
                            value: "normal",
                            label: "Normal"
                        },
                        {
                            value: "proportional",
                            label: "Proportional"
                        }
                    ]
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-3"
            },
            {
                name: "rtp",
                fieldType: "input",
                fieldOptions: {
                    id: "rtp",
                    inputType: "text",
                    label: "RTP",
                    placeholder: "RTP",
                },
                columnClass: "col-9",
                formSpacing: false
            }
        ]
    }
);

export const JumboLinkSettingsConfigFieldsNoCoin = _.memoize(
    (): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        }
    ]
);

export const gamesSubForm = _.memoize(
    (coins, defaultsValues, completeList, bundlesList, selectedGames, hasCoinsField): SubFormDefinition => {
        return {
            formType: "gameSpecificSettings",
            addLabel: "",
            emptyValue: defaultsValues,
            fields: gamesConfigFields(coins, completeList, bundlesList, selectedGames, hasCoinsField)
        };
    }
)

const gamesConfigFields = _.memoize(
    (coins, completeList, bundlesList, selectedGames, hasCoinsField) => {
        let fields;
        fields = [
            {
                name: "name",
                fieldType: "input",
                fieldOptions: {
                    id: "GroupConfigName",
                    placeholder: "Progressive Setting Name",
                    inputType: "text",
                    label: "Progressive Setting Name"
                },
                validation: Yup.string()
                    .required("Field is required."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "game_instances",
                fieldType: "gameSelector",
                fieldOptions: {
                    id: "game_instances",
                    label: "Game Bundles",
                    completeList: completeList,
                    selectedGames: selectedGames,
                    bundlesList: bundlesList,
                    multipleSelection: true
                },
                validation: Yup.array().required("Field is required."),
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },
            {
                name: "setting_keys_group",
                fieldType: "group",
                fieldOptions: {
                    id: "settingKeys",
                    inputType: "group",
                    label: "Setting Keys"
                },
                formSpacing: false,
                columnClass: "col-12"
            },
            {
                name: "base_extra_ball_value",
                fieldType: "number",
                fieldOptions: {
                    id: "base_extra_ball_value",
                    placeholder: "Base Extra Ball Value",
                    inputType: "text",
                    label: "Base Extra Ball Value"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "deduction_percent",
                fieldType: "number",
                fieldOptions: {
                    id: "deduction_percent",
                    placeholder: "Deducted Percentage",
                    inputType: "text",
                    label: "Deducted Percentage"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_machine_coin_in",
                fieldType: "number",
                fieldOptions: {
                    id: "min_machine_coin_in",
                    placeholder: "Min. Machine Coin In",
                    inputType: "text",
                    label: "Min. Machine Coin In"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_room_games_started",
                fieldType: "number",
                fieldOptions: {
                    id: "min_room_games_started",
                    placeholder: "Min. Room Games Started",
                    inputType: "text",
                    label: "Min. Room Games Started"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "proportion_type",
                fieldType: "select",
                fieldOptions: {
                    id: "proportion_type",
                    noValueLabel: "Proportion Type...",
                    label: "Proportion Type",
                    items: [
                        {
                            value: "normal",
                            label: "Normal"
                        },
                        {
                            value: "proportional",
                            label: "Proportional"
                        }
                    ]
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-3"
            },
            {
                name: "frequency_prize0",
                fieldType: "number",
                fieldOptions: {
                    id: "frequency_prize0",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 0"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "frequency_prize1",
                fieldType: "number",
                fieldOptions: {
                    id: "frequency_prize1",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 1"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "frequency_prize2",
                fieldType: "number",
                fieldOptions: {
                    id: "frequency_prize2",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 2"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "frequency_prize3",
                fieldType: "number",
                fieldOptions: {
                    id: "frequency_prize3",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 3"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "frequency_prize4",
                fieldType: "number",
                fieldOptions: {
                    id: "frequency_prize4",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 4"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "prize_range",
                fieldType: "number",
                fieldOptions: {
                    id: "prize_range",
                    placeholder: "Prize Range",
                    inputType: "text",
                    label: "Prize Range"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0.")
                    .test({
                        name: "sum",
                        exclusive: false,
                        params: {},
                        message: "Must be > then Frequencies (SUM)",
                        test: function (value) {
                            return (
                                sum([
                                    this.parent.frequency_prize0,
                                    this.parent.frequency_prize1,
                                    this.parent.frequency_prize2,
                                    this.parent.frequency_prize3,
                                    this.parent.frequency_prize4
                                ]) < value
                            );
                        }
                    }),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_game_mode0",
                fieldType: "number",
                fieldOptions: {
                    id: "min_game_mode0",
                    placeholder: "Min. Game Mode",
                    inputType: "text",
                    label: "Min. Game Mode 0"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_game_mode1",
                fieldType: "number",
                fieldOptions: {
                    id: "min_game_mode1",
                    placeholder: "Min. Game Mode",
                    inputType: "text",
                    label: "Min. Game Mode 1"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_game_mode2",
                fieldType: "number",
                fieldOptions: {
                    id: "min_game_mode2",
                    placeholder: "Min. Game Mode",
                    inputType: "text",
                    label: "Min. Game Mode 2"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_game_mode3",
                fieldType: "number",
                fieldOptions: {
                    id: "min_game_mode3",
                    placeholder: "Min. Game Mode",
                    inputType: "text",
                    label: "Min. Game Mode 3"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "min_game_mode4",
                fieldType: "number",
                fieldOptions: {
                    id: "min_game_mode4",
                    placeholder: "Min. Game Mode",
                    inputType: "text",
                    label: "Min. Game Mode 4"
                },
                validation: Yup.number()
                    .required("Field is required.")
                    .min(0, "Value must be >= 0."),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "rtp",
                fieldType: "input",
                fieldOptions: {
                    id: "rtp",
                    inputType: "text",
                    label: "RTP",
                    placeholder: "RTP",
                },
                columnClass: "col-12",
                formSpacing: false
            }
        ]
        if (hasCoinsField) {
            fields.push({
                name: "coin",
                fieldType: "bulletsSelector",
                fieldOptions: {
                    id: "proportional_coin",
                    inputType: "bulletsSelector",
                    label: "Coin",
                    items: coins,
                    completeList: coins
                },
                validation: Yup.string().required("Field is required."),
                columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                formSpacing: false
            },)
        }

        fields.push({
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        })

        fields.push(
            {
                name: "buytype_settings_group",
                fieldType: "group",
                fieldOptions: {
                    id: "buytypeSettingsGroup",
                    inputType: "group",
                    label: "Buy Bonus Settings (optional)"
                },
                formSpacing: false,
                columnClass: "col-12"
            },
            {
                name: "buytype_frequency_prize0",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_frequency_prize0",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 0"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "buytype_frequency_prize1",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_frequency_prize1",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 1"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "buytype_frequency_prize2",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_frequency_prize2",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 2"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "buytype_frequency_prize3",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_frequency_prize3",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 3"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "buytype_frequency_prize4",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_frequency_prize4",
                    placeholder: "Prize Frequency",
                    inputType: "text",
                    label: "Prize Frequency 4"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            },
            {
                name: "buytype_prize_range",
                fieldType: "number",
                fieldOptions: {
                    id: "buytype_prize_range",
                    placeholder: "Prize Range",
                    inputType: "text",
                    label: "Prize Range"
                },
                validation: positiveIntegerValidation(),
                columnClass: "col-3",
                formSpacing: false
            }
        )

        return fields
    }
);

/*
export const LuckyTokensLinkConfigFields = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);

 */

export const LuckyTokensLinkConfigFieldsNoCoin = _.memoize(
    ({coins}): FormGridField[] => [
        {
            name: "base_extra_ball_value",
            fieldType: "number",
            fieldOptions: {
                id: "base_extra_ball_value",
                placeholder: "Base Extra Ball Value",
                inputType: "text",
                label: "Base Extra Ball Value"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "deduction_percent",
            fieldType: "number",
            fieldOptions: {
                id: "deduction_percent",
                placeholder: "Deducted Percentage",
                inputType: "text",
                label: "Deducted Percentage"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_machine_coin_in",
            fieldType: "number",
            fieldOptions: {
                id: "min_machine_coin_in",
                placeholder: "Min. Machine Coin In",
                inputType: "text",
                label: "Min. Machine Coin In"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "min_room_games_started",
            fieldType: "number",
            fieldOptions: {
                id: "min_room_games_started",
                placeholder: "Min. Room Games Started",
                inputType: "text",
                label: "Min. Room Games Started"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "proportion_type",
            fieldType: "select",
            fieldOptions: {
                id: "proportion_type",
                noValueLabel: "Proportion Type...",
                label: "Proportion Type",
                items: [
                    {
                        value: "normal",
                        label: "Normal"
                    },
                    {
                        value: "proportional",
                        label: "Proportional"
                    }
                ]
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-3"
        },
        {
            name: "frequency_prize0",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize0",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 0"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize1",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize1",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 1"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize2",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize2",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 2"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize3",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize3",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 3"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "frequency_prize4",
            fieldType: "number",
            fieldOptions: {
                id: "frequency_prize4",
                placeholder: "Prize Frequency",
                inputType: "text",
                label: "Prize Frequency 4"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0."),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "prize_range",
            fieldType: "number",
            fieldOptions: {
                id: "prize_range",
                placeholder: "Prize Range",
                inputType: "text",
                label: "Prize Range"
            },
            validation: Yup.number()
                .required("Field is required.")
                .min(0, "Value must be >= 0.")
                .test({
                    name: "sum",
                    exclusive: false,
                    params: {},
                    message: "Must be > then Frequencies (SUM)",
                    test: function (value) {
                        return (
                            sum([
                                this.parent.frequency_prize0,
                                this.parent.frequency_prize1,
                                this.parent.frequency_prize2,
                                this.parent.frequency_prize3,
                                this.parent.frequency_prize4
                            ]) < value
                        );
                    }
                }),
            columnClass: "col-3",
            formSpacing: false
        },
        {
            name: "rtp",
            fieldType: "input",
            fieldOptions: {
                id: "rtp",
                inputType: "text",
                label: "RTP",
                placeholder: "RTP",
            },
            columnClass: "col-12",
            formSpacing: false
        },
        {
            name: "coin",
            fieldType: "bulletsSelector",
            fieldOptions: {
                id: "proportional_coin",
                inputType: "bulletsSelector",
                label: "Coin",
                items: coins,
                completeList: coins
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            formSpacing: false
        },
        {
            name: "prize_value_distribution",
            fieldType: "numbersArray",
            fieldOptions: {
                id: "prize_value_distribution",
                inputType: "numbersArray",
                placeholder: "Insert Value and press Enter",
                label: "Prize value distribution"
            },
            validation: Yup.array(Yup.object({
                value: Yup.number().required().moreThan(-1).integer(),
                repeat: Yup.number().required().moreThan(-1).integer()
            })),
            columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
            formSpacing: false
        }
    ]
);
